function values(...parts: Array<string | null | undefined>): string[] {
  return parts.map((part) => String(part || '').trim()).filter(Boolean);
}

/** Kopplingen träffar nyckeln via asset-id eller OnPrem KeyId. */
export function liveKeyMatchesStored(
  liveId: string | null | undefined,
  liveKeyNumber: string | null | undefined,
  storedKeyId: string | null | undefined,
  storedKeywinKeyId?: string | null
): boolean {
  const stored = new Set(values(storedKeyId, storedKeywinKeyId));
  if (stored.size === 0) return false;
  return values(liveId, liveKeyNumber).some((value) => stored.has(value));
}
